import PlaylistAddRounded from '@mui/icons-material/PlaylistAddRounded';
import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';

import { EditorDefaultSidePanelType, setActiveSidePanel } from '../../grid/reduxStore/blockStyleSettingsSlice';
import { useBlockContent } from '../../Sections/useBlockContent';
import { GridBlockType } from 'services/entities/BlockTypes';
import { SelectionContext } from '../SelectedBlockInfoProvider';
import BlockSettingsToolButton from './BlockSettingsToolButton';
import { useBlockLockStatus } from '../../hooks/useBlockLockStatus';

export interface AssetInsertToolProps {
  blockId: string;
}
export default function AssetInsertTool({ blockId }: AssetInsertToolProps) {
  const dispatch = useDispatch();
  const blockContent = useBlockContent(blockId);
  const { setSelectedBlockInfoByWrapper } = useContext(SelectionContext);
  const { isLocked } = useBlockLockStatus(blockId);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setSelectedBlockInfoByWrapper({ blockId, sectionId: null });
      dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.TEXT_SNIPPET_LIBRARY_PANEL }));
    },
    [blockId, dispatch, setSelectedBlockInfoByWrapper]
  );

  if (blockContent?.type !== GridBlockType.TEXT) {
    return null;
  }

  if (isLocked) {
    return null;
  }

  return (
    <BlockSettingsToolButton title="Insert a snippet" onMouseDown={handleClick}>
      <PlaylistAddRounded width={24} height={24} fontSize="small" color="inherit" />
    </BlockSettingsToolButton>
  );
}
